import makeArrayMethod from './shared/makeArrayMethod';
export default makeArrayMethod( 'unshift' ).path;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/unshift.js.map
